import { createPinia } from 'pinia';
import { resetStore } from 'freedom-shared';
import type { App } from 'vue';

import { appConfig } from '@/shared/config';

declare global {
  interface Window {
    isPiniaInitialized: boolean;
  }
}

export const withPinia = (app: App) => {
  const pinia = createPinia();
  pinia.use(resetStore);
  app.use(pinia);

  /* Need this field in debug bar to prevent initializing pinia twice */
  if (!appConfig.isProdRuntimeEnv) {
    window.isPiniaInitialized = true;
  }
};
